import React, { useEffect, useState } from "react";
import GalleryView from "./GalleryView";
import AddToGalleryView from "./AddToGalleryView";
import EditImageView from "./EditImageView";

const GalleryWorkflow = function() {

  const Views = {
    Gallery: 1,
    AddImage: 2,
    EditImage: 3
  }

  const [currentView, setCurrentView] = useState(Views.Gallery);
  const [selectedImage, setSelectedImage] = useState(null);

  /**
   * Redners the view JSX based on the selected view.
   * @returns 
   */
  const renderView = () => {
    let viewJsx = null;

    switch (currentView) {
      case Views.Gallery:
        viewJsx = <GalleryView workflowViews={Views} setWorkflowView={setCurrentView} updateSelectedImage={setSelectedImage} />;
        break;

      case Views.AddImage:
        viewJsx = <AddToGalleryView workflowViews={Views} setWorkflowView={setCurrentView} />
        break;

      case Views.EditImage:
        viewJsx = <EditImageView workflowViews={Views} setWorkflowView={setCurrentView} selectedImage={selectedImage} />
        break;
    }

    return viewJsx;
  }

  return renderView();
}

export default GalleryWorkflow; 